export default __webpack_public_path__ + "static/media/Tapas-Nayak.e7b5b2e5.jpg";